$(document).ready(function () {

var lastLoadedUrl = '';
  $(window).scroll(function() {
   if($(window).scrollTop() + $(window).height() == $(document).height()) {
				scrollNode = $('.product#more').last();    
               scrollURL = $('.product#more a').last().attr("href");
               $('#collection-loader').show();
               
	 if(scrollURL && (scrollURL!=lastLoadedUrl)){
       $.ajax({
                       type: 'GET',
                       url: scrollURL,
                       beforeSend: function() {
					   lastLoadedUrl = scrollURL;
                       },
                       success: function(data) {
                           scrollNode.remove();
                           var filteredData = $(data).find(".product");
                           filteredData.insertBefore( $("#product-list-foot") );   
							$('.th_img_wrapper').hover(function(){
						        $(this).addClass('hovered');
						    }, function() {
						        $(this).removeClass('hovered');
						    });
                         

                         
							$('#collection-loader').hide();						    
							lastUrl = scrollURL;
                         
                         	resizeProductImages();
                       },
                       dataType: "html"
		});
	  } else {
		  	$('#collection-loader').hide();						    
	  }
   }
 });
});